module.exports = __webpack_public_path__ + "static/media/chair.efdeab0b.svg";